// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function Concours() {

    var self = this,
      $form = null,
      options = {
        'example': null
      };
    //---------
    // Concours Form Validate
    //---------
    var $formValidate = $('.js-contest-form');
    if($formValidate.length > 0) {
      $formValidate.each(function(){
        $(this).validate({
        submitHandler: function(form) {
          var $form = $(form);
          var formData = new FormData($form[0]);
          $.ajax({
              method: $form.attr('method'),
              url: $form.attr('action'),
              data: formData,
              dataType: 'json',
              cache: false,
              contentType: false,
              processData: false,
              success: function(res) {
                
                  // Manual error from server
                  var msgSuccess = $form.find('.js-form-success');
                  var msgError = $form.find('.js-form-error');
                  $form[0].reset();

                  msgSuccess.hide();
                  msgError.hide();                  

                  if (res.success === false) {
                      if (res.message) {
                        msgError.html(res.message);
                      }
                      msgError.show();
                      return false;
                  }

                  // Show message
                  if (res.success) {
                      if (res.message) {
                        msgSuccess.html(res.message);
                      }
                      msgSuccess.show();
                      // setTimeout(function () {
                      //   $('.js-close-popup').trigger('click'); 
                      //   msgSuccess.hide();
                   
                      // }, 2000);
                      // if (dataLayer !== 'undefined') {
                      //   dataLayer.push({'event': 'form-submit'});
                      // }
                  }

                  // Show mailchimp response message
                  // console.log(res.mailchimpAdd)
              },
              error: function(errorThrown) {
                  // Show message
                  console.log('Error: ', errorThrown);
                  console.log(formData);
                  return false;
              }
          });
        }
      });
      });
    }


  

    /**
     * Generic resize 
     */
    function onResize() {
    }

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
    

      //*************
      window.cache.$window.on('resize', Utils.debounce(onResize, 400));
      onResize();     // initial call on load
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Components.Concours = Concours;

}(jQuery));